export const export_report = {
  export_btn: 'Export report',
  xls: 'xls',
  csv: 'csv',
  export_modal: 'Export',
  export_records: 'Export records'
};
